import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import floris.graphics.backoffice.pages.admin.AdminPage as _floris_graphics_backoffice_pages_admin_AdminPage
import floris.graphics.backoffice.pages.admin.LoginPage as _floris_graphics_backoffice_pages_admin_LoginPage
import floris.graphics.backoffice.pages.admin.categories.CategoriesPage as _floris_graphics_backoffice_pages_admin_categories_CategoriesPage
import floris.graphics.backoffice.pages.admin.categories.manage.ManageCategoryPage as _floris_graphics_backoffice_pages_admin_categories_manage_ManageCategoryPage
import floris.graphics.backoffice.pages.admin.contributors.ContributorsPage as _floris_graphics_backoffice_pages_admin_contributors_ContributorsPage
import floris.graphics.backoffice.pages.admin.contributors.manage.ManageContributorPage as _floris_graphics_backoffice_pages_admin_contributors_manage_ManageContributorPage
import floris.graphics.backoffice.pages.admin.projects.ProjectsPage as _floris_graphics_backoffice_pages_admin_projects_ProjectsPage
import floris.graphics.backoffice.pages.admin.projects.manage.ManageProjectPage as _floris_graphics_backoffice_pages_admin_projects_manage_ManageProjectPage
import floris.graphics.backoffice.pages.admin.settings.SettingsPage as _floris_graphics_backoffice_pages_admin_settings_SettingsPage
import floris.graphics.backoffice.pages.admin.techstacks.TechstacksPage as _floris_graphics_backoffice_pages_admin_techstacks_TechstacksPage
import floris.graphics.backoffice.pages.admin.techstacks.manage.ManageTechstackPage as _floris_graphics_backoffice_pages_admin_techstacks_manage_ManageTechstackPage
import floris.graphics.core.pages.AboutPage as _floris_graphics_core_pages_AboutPage
import floris.graphics.landing.pages.HomePage as _floris_graphics_landing_pages_HomePage
import floris.graphics.landing.pages.projects.ProjectPage as _floris_graphics_landing_pages_projects_ProjectPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Floris.Graphics", "BASE_URL" to "https://floris-graphics.cb-connect-it.com"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _floris_graphics_landing_pages_HomePage()
        }
        ctx.router.register(
            "/about",
        ) { pageCtx -> 
            _floris_graphics_core_pages_AboutPage()
        }
        ctx.router.register(
            "/admin/",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_AdminPage()
        }
        ctx.router.register(
            "/admin/categories",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_categories_CategoriesPage()
        }
        ctx.router.register(
            "/admin/categories/manage",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_categories_manage_ManageCategoryPage()
        }
        ctx.router.register(
            "/admin/contributors",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_contributors_ContributorsPage()
        }
        ctx.router.register(
            "/admin/contributors/manage",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_contributors_manage_ManageContributorPage()
        }
        ctx.router.register(
            "/admin/login",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_LoginPage()
        }
        ctx.router.register(
            "/admin/projects",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_projects_ProjectsPage()
        }
        ctx.router.register(
            "/admin/projects/manage",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_projects_manage_ManageProjectPage()
        }
        ctx.router.register(
            "/admin/settings",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_settings_SettingsPage()
        }
        ctx.router.register(
            "/admin/techstacks",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_techstacks_TechstacksPage()
        }
        ctx.router.register(
            "/admin/techstacks/manage",
        ) { pageCtx -> 
            _floris_graphics_backoffice_pages_admin_techstacks_manage_ManageTechstackPage()
        }
        ctx.router.register(
            "/project",
        ) { pageCtx -> 
            _floris_graphics_landing_pages_projects_ProjectPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("media-frame", floris.graphics.backoffice.pages.admin.projects.manage.MediaFrameStyle)
        ctx.theme.registerStyle("tab", floris.graphics.landing.components.widgets.TabStyle)
        ctx.theme.registerStyle("valid-feedback", com.materialdesignsystem.styles.validFeedbackStyle)
        ctx.theme.registerStyle("invalid-feedback", com.materialdesignsystem.styles.invalidFeedbackStyle)
        ctx.theme.registerStyle("button-size-xl", com.materialdesignsystem.extensions.ButtonSizeXL)
        ctx.theme.registerStyle("ds-external-link", com.materialdesignsystem.components.widgets.DsExternalLinkStyle)
        ctx.theme.registerStyle("checked-input", com.materialdesignsystem.components.widgets.CheckedInputStyle)
        ctx.theme.registerStyle("select", com.materialdesignsystem.components.widgets.SelectStyle)
        ctx.theme.registerStyle("valid-select", com.materialdesignsystem.components.widgets.validSelectStyle)
        ctx.theme.registerStyle("invalid-select", com.materialdesignsystem.components.widgets.invalidSelectStyle)
        ctx.theme.registerStyle("select-form-floating", com.materialdesignsystem.components.widgets.SelectFormFloating)
        ctx.theme.registerStyle("select-defaults_size", com.materialdesignsystem.components.widgets.SelectDefaults.Size)
        ctx.theme.registerStyle("select-size_xs", com.materialdesignsystem.components.widgets.SelectSize.Companion.XS)
        ctx.theme.registerStyle("select-size_sm", com.materialdesignsystem.components.widgets.SelectSize.Companion.SM)
        ctx.theme.registerStyle("select-size_md", com.materialdesignsystem.components.widgets.SelectSize.Companion.MD)
        ctx.theme.registerStyle("select-size_lg", com.materialdesignsystem.components.widgets.SelectSize.Companion.LG)
        ctx.theme.registerStyle("silk-text-area", com.materialdesignsystem.components.widgets.TextAreaStyle)
        ctx.theme.registerStyle("multi-select", com.materialdesignsystem.components.widgets.MultiSelectStyle)
        ctx.theme.registerStyle("multi-select-defaults_size", com.materialdesignsystem.components.widgets.MultiSelectDefaults.Size)
        ctx.theme.registerStyle("multi-select-size_xs", com.materialdesignsystem.components.widgets.MultiSelectSize.Companion.XS)
        ctx.theme.registerStyle("multi-select-size_sm", com.materialdesignsystem.components.widgets.MultiSelectSize.Companion.SM)
        ctx.theme.registerStyle("multi-select-size_md", com.materialdesignsystem.components.widgets.MultiSelectSize.Companion.MD)
        ctx.theme.registerStyle("multi-select-size_lg", com.materialdesignsystem.components.widgets.MultiSelectSize.Companion.LG)
        ctx.theme.registerStyle("ds-card", com.materialdesignsystem.components.widgets.DsCardStyle)
        ctx.theme.registerStyle("navigation-item", com.materialdesignsystem.components.sections.NavigationItemStyle)
        ctx.theme.registerVariant("-h4", floris.graphics.backoffice.components.H4SpanTextVariant
        )
        ctx.theme.registerVariant("-elevated-icon-button-style", com.materialdesignsystem.components.widgets.ElevatedIconButtonStyle
        )
        ctx.theme.registerVariant("-filled-icon-button-style", com.materialdesignsystem.components.widgets.FilledIconButtonStyle
        )
        ctx.theme.registerVariant("-outlined-icon-button-style", com.materialdesignsystem.components.widgets.OutlinedIconButtonStyle
        )
        ctx.theme.registerVariant("-filled-tonal-icon-button-style", com.materialdesignsystem.components.widgets.FilledTonalIconButtonStyle
        )
        ctx.theme.registerVariant("-icon-button-style", com.materialdesignsystem.components.widgets.IconButtonStyle
        )
        ctx.theme.registerVariant("-outlined-select-style", com.materialdesignsystem.components.widgets.OutlinedSelectStyle
        )
        ctx.theme.registerVariant("-unstyled-select-style", com.materialdesignsystem.components.widgets.UnstyledSelectStyle
        )
        ctx.theme.registerVariant("-", com.materialdesignsystem.components.widgets.SelectDefaults.Variant
        )
        ctx.theme.registerVariant("-outlined", com.materialdesignsystem.components.widgets.OutlinedTextAreaVariant
        )
        ctx.theme.registerVariant("-outlined-multi-select-style", com.materialdesignsystem.components.widgets.OutlinedMultiSelectStyle
        )
        ctx.theme.registerVariant("-", com.materialdesignsystem.components.widgets.MultiSelectDefaults.Variant
        )
        ctx.theme.registerVariant("-elevated-button-style", com.materialdesignsystem.components.widgets.ElevatedButtonStyle
        )
        ctx.theme.registerVariant("-filled-button-style", com.materialdesignsystem.components.widgets.FilledButtonStyle
        )
        ctx.theme.registerVariant("-outlined-button-style", com.materialdesignsystem.components.widgets.OutlinedButtonStyle
        )
        ctx.theme.registerVariant("-filled-tonal-button-style", com.materialdesignsystem.components.widgets.FilledTonalButtonStyle
        )
        ctx.theme.registerVariant("-text-button-style", com.materialdesignsystem.components.widgets.TextButtonStyle
        )
        ctx.theme.registerKeyframes("rotation-key-frames", com.materialdesignsystem.components.widgets.rotationKeyFrames)
        floris.graphics.site.updateTheme(ctx)
        com.materialdesignsystem.updateTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        floris.graphics.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
